
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { FgiBackEndService } from '../fgi-back-end.service';
import { Observable } from 'rxjs';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { DetalheConsultaEmpresa, ProtocoloConsultaEmpresa } from 'src/app/model/protocolo-consulta-empresa.model';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";

@Injectable({
    providedIn: 'root'
})
export class ProtocoloConsultaEmpresaService extends FgiBackEndService<any> {

    // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
    getNewEntity() {
        return new ProtocoloConsultaEmpresa();
    }

    // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
    protected getResourceURL(): string {
        return 'front/protocolo-consulta-empresa';
    }

    public getArquivosPorAgente(params?: any, options?: any): Observable<ResultadoPaginado<ProtocoloConsultaEmpresa>> {

        const url = `${this.BASE_URL}/`;

        return this.http.get(url, {params: params}).pipe(
            catchError(this.handleError)
        ) as Observable<ResultadoPaginado<ProtocoloConsultaEmpresa>>;
    }

    public getDetalheExportar(params?: any, options?: any): Observable<DetalheConsultaEmpresa[]> {

        const url = `${this.BASE_URL}/exportar`;

        return this.http.get(url, {params: params}).pipe(
            catchError(this.handleError)
        ) as Observable<DetalheConsultaEmpresa[]>;
    }

    public getArquivoEnvio(idProtocoloArquivo: string): Observable<string> {
        const url = `${this.BASE_URL}/${idProtocoloArquivo}/enviado`;
        return this.http.get(url, blockUi()).pipe(
            catchError(this.handleError)
        ) as Observable<string>;
    }
    
    public getArquivoResposta(idProtocoloArquivo: string): Observable<string> {
        const url = `${this.BASE_URL}/${idProtocoloArquivo}/resposta`;
        return this.http.get(url, blockUi()).pipe(
            catchError(this.handleError)
        ) as Observable<string>;
    }
}
